<template>
  <div class="ustn common-bg padding-nav">
    <page-menu />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import pageMenu from "./pageMenu/index.vue";
import Web3 from "web3";
export default {
  components: {
    pageMenu
  },
  data() {
    return {
      aList: [
        {
          type: "Treasurenet",
          name: process.env.VUE_APP_TN_CHAIN_NAME.toLowerCase(),
          id: process.env.VUE_APP_TN_CHAINID.toLowerCase(),
          rpcUrls: process.env.VUE_APP_TN_RPC_URLS.toLowerCase(),
          nativeCurrency: {
            name: "UNIT",
            symbol: "UNIT",
            decimals: 18
          }
        },
        {
          type: "Ethereum",
          name: process.env.VUE_APP_ETH_NAME.toLowerCase(),
          id: process.env.VUE_APP_ETH_CHAINID.toLowerCase(),
          rpcUrls: JSON.parse(process.env.VUE_APP_ETH_RPC_URLS),
          // nativeCurrency: {
          //   name: "WTCash",
          //   symbol: "WTCash",
          //   decimals: 18
          // }
        }
      ],
      // aList: [
      //   {
      //     type: "Ethereum",
      //     name: process.env.VUE_APP_Gl_NAME.toLocaleLowerCase(),
      //     id: process.env.VUE_APP_GLINID.toLocaleLowerCase(),
      //     rpcUrls: process.env.VUE_APP_GL_RPC_URLS.toLocaleLowerCase(),
      //     nativeCurrency: { name: "UNIT", symbol: "UNIT", decimals: 18 }
      //   },
      //   {
      //     type: "Treasurenet",
      //     name: process.env.VUE_APP_CHAIN_NAME.toLocaleLowerCase(),
      //     id: process.env.VUE_APP_TN_CHAINID.toLocaleLowerCase(),
      //     rpcUrls: JSON.parse(process.env.VUE_APP_RPC_URLS),
      //     nativeCurrency: { name: "UNIT", symbol: "UNIT", decimals: 18 }
      //   }
      // ],
      account: ""
    };
  },
  computed: {},
  watch: {
    "$store.getters.metaMaskObj.account": {
      handler(val) {
        if (val) {
          this.account = val;
          this.getCurr();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getCurr();
  },
  methods: {
    async getCurr() {
      let web3 = new Web3(window.ethereum);
      let res = await ethereum.request({ method: "eth_chainId" });
      let chainId = res;
      let currType = this.aList.filter(item => item.id == chainId);
      if (currType.length != 0) {
        if (currType[0].type != "Treasurenet") {
          this.changeNetwork();
        }
      } else {
        this.changeNetwork();
      }
    },
    async changeNetwork() {
      // let currName = this.toType;
      let obj = this.aList.filter(item => item.type === "Treasurenet");
      await window.ethereum
        .request({
          method: "wallet_switchEthereumChain",
          params: [
            {
              chainId: obj[0].id
            }
          ]
        })
        .then(res => {
          let f = this.fromType;
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: ""
          });
          setTimeout(() => {
            this.$store.commit("app/SET_MATEMASK", {
              isConnect: true,
              account: this.account
            });
          }, 100);
          // this.fromType = this.toType;
          // this.toType = f;
          // this.exchangeNum = undefined;
          // this.exchangeNum1 = undefined;
          // this.onClickConnect();
        })
        .catch(err => {
          if (err.code === 4902) {
            let { ethereum } = window;
            ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: obj[0].id,
                  chainName: obj[0].name,
                  rpcUrls: obj[0].rpcUrls,
                  nativeCurrency: {
                    name: obj[0].nativeCurrency.name,
                    symbol: obj[0].nativeCurrency.symbol,
                    decimals: obj[0].nativeCurrency.decimals
                  }
                }
              ]
            });
          }
          if (err.code == 4001) {
            this.$store.commit("app/SET_MATEMASK", {
              isConnect: true,
              account: ""
            });
            return;
          }
        });
    }
  }
};
</script>
<style scoped lang="scss">
.ustn {
  .common-line {
    height: 1px;
    width: 70%;
    margin: 1.73rem auto 1.38rem auto;
    background: linear-gradient(91deg, #efefef, #cccccc, #efefef);
  }
}
</style>
